module.exports = __webpack_public_path__ + "static/media/23.0ec0d89c.mp3";